module.exports = __webpack_public_path__ + "files/cf7356a3ed573e3ecefc9404e10eb1e1.png";